export function expirationDate(expiresIn: Date, currentDate: Date) {
  const timeDifference = expiresIn.getTime() - currentDate.getTime();
  return Math.floor(timeDifference / (1000 * 3600 * 24));
}

export function getDaysUntilExpiresByDate(expirationDate: Date, currentDate: Date) {
  expirationDate.setHours(0, 0, 0, 0);
  currentDate.setHours(0, 0, 0, 0);
  return Math.floor((expirationDate.getTime() - currentDate.getTime()) / (1000 * 3600 * 24));
}

export function isExpiredByDate(expirationDate: Date, currentDate: Date): boolean {
  expirationDate.setHours(0, 0, 0, 0);
  currentDate.setHours(0, 0, 0, 0);

  return expirationDate <= currentDate;
}
